import { Component } from '@angular/core';
import * as html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-recibo',
  templateUrl: './recibo.component.html',
  styleUrls: ['./recibo.component.scss']
})
export class ReciboComponent {
  exportarPdf() {
    const options = {
      fileName: `relatorio.pdf`,
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'portrait', format: 'a4' }
    };
    const content: Element | null = document.getElementById('recibo');

    html2pdf().from(content).set(options).save();
  }
}
